module.exports = __webpack_public_path__ + "static/media/americanexpress.7240d447.svg";